import { render, staticRenderFns } from "./updateUserPermissions.vue?vue&type=template&id=ec758f22&scoped=true"
import script from "./updateUserPermissions.vue?vue&type=script&lang=js"
export * from "./updateUserPermissions.vue?vue&type=script&lang=js"
import style0 from "./updateUserPermissions.vue?vue&type=style&index=0&id=ec758f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec758f22",
  null
  
)

export default component.exports